import axios from 'axios'
import { getGraphURL } from '@mfs/client/utils/getServiceUrl'
import { logSearchError } from '../../listings-client/util/clientLogger'
import { generatePhoneBookPackagesCall } from './queries/generatePhoneBookPackagesCall'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'
import { get } from 'lodash'

export const generatePhoneBookPackagesNumber = (phoneBookInput) => {
  if (Object.keys(phoneBookInput).length > 0) {
    return new Promise((resolve, reject) => {
      axios({
        url: getGraphURL({ operationName: 'getPhoneBookPackagesNumber' }),
        method: 'post',
        data: {
          query: generatePhoneBookPackagesCall,
          variables: { request: phoneBookInput },
        },
        headers: {
          'apollographql-client-name': `${APOLLO_CLIENT_NAME}`,
          'apollographql-client-version': get(
            window,
            'PCLN_BOOTSTRAP_DATA.appInfo.appVersion',
            'development'
          ),
        },
      })
        .then((response) => resolve(response?.data?.data?.phoneBookPackages))
        .catch((error) => {
          logSearchError('phoneBookPackgesCall', error)
          reject(error)
        })
    })
  } else {
    return Promise.resolve('phoneBookInput empty')
  }
}
